import { ASSET_IDS } from "@/utils/constants";

export interface ProcessConfig {
  title: string;
  assetName: string;
  dataEntryRoute: string;
  procedureName: string;
}

const PROCESS_CONFIGS: { [key: number]: ProcessConfig } = {
  [ASSET_IDS.EAF]: {
    title: "EAF Production Report",
    assetName: "EAF",
    dataEntryRoute: "eaf-data-entry",
    procedureName: "EAF.GetProcessesByDateRange",
  },
  [ASSET_IDS.LMF]: {
    title: "LMF Production Report",
    assetName: "LMF",
    dataEntryRoute: "lmf-data-entry",
    procedureName: "LMF.GetProcessesByDateRange",
  },
  [ASSET_IDS.CASTER]: {
    title: "Caster Production Report",
    assetName: "CASTER",
    dataEntryRoute: "caster-data-entry",
    procedureName: "CAS.GetProcessesByDateRange",
  },
};

export const useProcessConfig = (assetId: number): ProcessConfig | null => {
  return PROCESS_CONFIGS[assetId] || null;
};
